"use client";

import { useEffect } from "react";

export default function MotionDetector() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const isLowEndDevice = navigator.hardwareConcurrency !== undefined && navigator.hardwareConcurrency <= 2;
    
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const shouldReduceAnimations = isLowEndDevice || prefersReducedMotion;

    if (shouldReduceAnimations) {
      document.documentElement.classList.add("reduce-animations");
    } else {
      document.documentElement.classList.remove("reduce-animations");
    }
  }, []);

  return null;
}
